import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { resolveRange } from "@/lib/settings/dateRanges";
import handleError from "../helpers/handleError";
import { DASHBOARD_FOCUS } from "@lib/enums";

export default function useDashboardStats({
  range,
  focus = DASHBOARD_FOCUS.FLOATS,
  enabled = true,
} = {}) {
  const api = useAxios();
  const resolved = resolveRange(range);

  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["dashboard-stats", focus, resolved?.from, resolved?.to],
    queryFn: () =>
      api.get("/dashboard/stats", {
        params: { from: resolved.from, to: resolved.to, focus },
      }),
    enabled: Boolean(enabled && resolved),
    placeholderData: keepPreviousData,
  });

  handleError(error);

  const stats = data?.data?.range ?? null;

  return { stats, isLoading, isFetching };
}
